// @ts-nocheck
// eslint-disable-next-line import/order

import './CartSumBox.scss'

import { Origin } from '@redteclab/api/clients/bully'
import { useCallback } from 'react'

import { withI18n } from 'shared/utils/withI18n'
import CreditBalanceCostDetails from 'views/components/organisms/CartSumBox/CreditBalanceCostDetails'
import { VoucherDetailsModalConnected } from 'views/components/organisms/VoucherDetailsModal'
import { VOUCHER_TYPE } from 'views/consts'
import { COST_DETAILS_TYPE } from 'views/consts/costDetails'

import CostDetails from './CostDetails'

export type SellerVoucherInfo = {
  sellerName: string
  vouchers: Pick<CartControllerCartSellerDiscountV2, 'code' | 'origin'>[]
}

const getVoucherLabel = (
  voucherCode: string,
  i18n: I18n,
  vouchersBySellers: SellerVoucherInfo[]
) => {
  const miraklVoucherData = vouchersBySellers.find(entry =>
    entry.vouchers.find(
      ({ code, origin }) => code === voucherCode && origin === Origin.Mirakl
    )
  )

  if (miraklVoucherData) {
    return i18n._('seller.promotion.discount.label', {
      sellerName: miraklVoucherData.sellerName,
    })
  }

  return voucherCode
}

const CostDetailsBox = ({
  vouchers,
  costDetails,
  rxBonusDiscount,
  applicableCredit,
  currency,
  i18n,
  vouchersBySellers,
  noModal = false,
}) => {
  const mappedCostDetails = costDetails.map(detail => ({
    key: `cost-details-${detail.id}`,
    purpose: detail.id,
    ...detail,
  }))

  const validateRedPoints = useCallback((): boolean => {
    const [redPointsCostDetails] = mappedCostDetails.filter(
      costDetail => costDetail.id === COST_DETAILS_TYPE.REDPOINTS
    )
    return Boolean(redPointsCostDetails) && Boolean(redPointsCostDetails.value)
  }, [mappedCostDetails])
  const isVoucherOrRedPoints: boolean =
    Boolean(vouchers.length) || validateRedPoints()

  const mappedRxDiscount = rxBonusDiscount
    ? [
        {
          key: 'rxDiscount',
          label: i18n._('general.cartSumBox.rxBonus.redeemable'),
          value: rxBonusDiscount * -1,
          purpose: 'rxDiscount',
        },
      ]
    : []

  return (
    <>
      {/*
        The order here should be:
          1. Vouchers
          2. RX Bonus
          3. RedPoints
          4. Shipping Cost
          5. Applicable Credit from AX
      */}
      {vouchers
        .filter(
          voucher =>
            voucher.type === VOUCHER_TYPE.VOUCHER &&
            voucher.promotionType !== 'linePercent'
        )
        .map((voucher, index) => {
          const modalId = `voucherDetails-${voucher.code}-${index}`
          return (
            <div key={`${voucher.code}_${index}`}>
              <CostDetails
                modal={noModal ? undefined : modalId}
                label={getVoucherLabel(voucher.code, i18n, vouchersBySellers)}
                value={-voucher.value}
                currency={currency}
                purpose="voucher"
                rowDataQaId={`applied-voucher-row-${voucher.code}`}
                priceDataQaIdPostfix={
                  voucher.origin === Origin.Mirakl ? voucher.code : undefined
                }
                title={getVoucherLabel(voucher.code, i18n, vouchersBySellers)}
              />
              {!noModal && (
                <VoucherDetailsModalConnected id={modalId} voucher={voucher} />
              )}
            </div>
          )
        })}

      {[
        ...mappedCostDetails.filter(
          detail => detail.id === 'appliedPromotions'
        ),
        ...mappedRxDiscount,
        ...mappedCostDetails.filter(detail => detail.id === 'RedPoints'),
        ...mappedCostDetails.filter(
          detail =>
            detail.id !== 'RedPoints' && detail.id !== 'appliedPromotions'
        ),
      ].map(props => (
        <CostDetails {...props} currency={currency} />
      ))}
      <CreditBalanceCostDetails
        isVoucherOrRedPoints={isVoucherOrRedPoints}
        applicableCredit={applicableCredit}
      />
    </>
  )
}

export default withI18n()(CostDetailsBox)
